// extracted by mini-css-extract-plugin
module.exports = {"nav":"JKG4S8K14ssKvMLFmmqH","slideNum":"ZNcscmTaz4NTV36881HI","root":"IIj_Oa4SmYD4FVWO8QkJ"};